"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatBytes = exports.initBaseFile = exports.FileType = exports.stateToColor = exports.stateToString = exports.ERROR_STATES = exports.FileState = void 0;
/* eslint-disable no-redeclare */
var lodash_1 = __importDefault(require("lodash"));
var FileState;
(function (FileState) {
    FileState[FileState["OK"] = 1] = "OK";
    FileState[FileState["EMPTY"] = 4] = "EMPTY";
    // Error
    FileState[FileState["INVALID_NAME"] = 2] = "INVALID_NAME";
    FileState[FileState["PARSING_ERROR"] = 3] = "PARSING_ERROR";
    FileState[FileState["INVALID_DOT"] = 21] = "INVALID_DOT";
    FileState[FileState["INVALID_STRUCTURE"] = 22] = "INVALID_STRUCTURE";
    FileState[FileState["INVALID_POPULATION_FILE_EXTENSION"] = 23] = "INVALID_POPULATION_FILE_EXTENSION";
    FileState[FileState["NO_PERMISSION"] = 24] = "NO_PERMISSION";
    // Warning
    FileState[FileState["UNRELATED_OPERATION_EVAL"] = 100] = "UNRELATED_OPERATION_EVAL";
    FileState[FileState["UNRELATED_FILE"] = 101] = "UNRELATED_FILE";
    FileState[FileState["ALREADY_EXISTING"] = 102] = "ALREADY_EXISTING";
    FileState[FileState["DIFFERENT_CONTROL_ID"] = 103] = "DIFFERENT_CONTROL_ID";
    // Saved file
    FileState[FileState["SAVED_FILE"] = 200] = "SAVED_FILE";
    // Skip record update for editing record.
    FileState[FileState["SKIP_RECORD_UPDATE"] = 201] = "SKIP_RECORD_UPDATE";
    // 승인완료 된 보고서
    FileState[FileState["NOT_EDITABLE"] = 300] = "NOT_EDITABLE";
    FileState[FileState["NOT_ALLOWED"] = 301] = "NOT_ALLOWED";
})(FileState = exports.FileState || (exports.FileState = {}));
exports.ERROR_STATES = [
    FileState.INVALID_NAME,
    FileState.PARSING_ERROR,
    FileState.NOT_EDITABLE,
    FileState.NOT_ALLOWED
];
var stateToString = function (evaluationType, state) {
    var message;
    switch (state) {
        case FileState.OK:
            message = '신규';
            break;
        case FileState.INVALID_NAME:
            message = '잘못된 이름의 파일';
            break;
        case FileState.INVALID_DOT:
            message = '확장자 표시 이외 "." 사용금지';
            break;
        case FileState.INVALID_STRUCTURE:
            if (evaluationType === 'operation') {
                message =
                    '1. 파일구조 : (업로드대상평가명)(업로드대상통제CODE)(보고서or증빙or모집단or기타 중 하나)파일명.확장자\n2. 괄호 등 파일 이름 규칙 준수 필수';
            }
            else {
                message =
                    '1. 파일구조 : (업로드대상평가명)(업로드대상통제CODE)(기타)파일명.확장자\n2. 괄호 등 파일 이름 규칙 준수 필수';
            }
            break;
        case FileState.INVALID_POPULATION_FILE_EXTENSION:
            message = '모집단 파일은 제공하는 Template 만 업로드 가능';
            break;
        case FileState.NO_PERMISSION:
            message = '권한 없음';
            break;
        case FileState.PARSING_ERROR:
            message = '보고서 파싱 실패';
            break;
        case FileState.UNRELATED_OPERATION_EVAL:
            message = '운영평가 이름이 다름';
            break;
        case FileState.UNRELATED_FILE:
            message = '관련 통제 번호가 운영평가에 없음';
            break;
        case FileState.ALREADY_EXISTING:
            message = '기존 항목 대체';
            break;
        case FileState.DIFFERENT_CONTROL_ID:
            message = '통제 번호가 다름';
            break;
        case FileState.SAVED_FILE:
            message = '저장된 파일';
            break;
        case FileState.NOT_EDITABLE:
            message = '이미 승인된 보고서';
            break;
        case FileState.NOT_ALLOWED:
            message = '수정 권한 없음';
            break;
        default:
            message = '에러';
            break;
    }
    return message;
};
exports.stateToString = stateToString;
var stateToColor = function (state) {
    var color = '#616161'; // grey
    if (lodash_1.default.includes(exports.ERROR_STATES, state)) {
        color = '#dd2c00'; // red
    }
    else if (state === FileState.ALREADY_EXISTING) {
        color = '#ff6d00'; // orange
    }
    else if (state === FileState.OK) {
        color = '#4caf50'; // green
    }
    else if (state === FileState.SAVED_FILE) {
        color = '#7D3C98'; // violet
    }
    return color;
};
exports.stateToColor = stateToColor;
exports.FileType = {
    Record: '보고서',
    Population: '모집단',
    Evidence: '증빙',
    Extra: '기타'
};
function initBaseFile(base) {
    if (!base) {
        return;
    }
    base.name = '';
    base.state = FileState.EMPTY;
    base.file = undefined;
    base.updateTime = '';
    base.updater = '';
}
exports.initBaseFile = initBaseFile;
function formatBytes(bytes, decimals) {
    if (bytes === 0)
        return '0 Bytes';
    var k = 1024;
    var dm = decimals < 0 ? 0 : decimals;
    var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    var i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}
exports.formatBytes = formatBytes;
//# sourceMappingURL=BaseFile.js.map